module.exports = __webpack_public_path__ + "static/media/custom-file-icon.b20bebe4.svg";